import { render, staticRenderFns } from "./EventTickets.vue?vue&type=template&id=027b6dda&scoped=true&"
import script from "./EventTickets.vue?vue&type=script&lang=js&"
export * from "./EventTickets.vue?vue&type=script&lang=js&"
import style0 from "./EventTickets.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EventTickets.vue?vue&type=style&index=1&id=027b6dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b6dda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideXReverseTransition})
